export default function XenophobiaHero() {
  return (
    <section className="xpb-hero" id="xpb-hero">
      <div className="xpb-hero__image xpb-hero__image--header" />
      <div className="xpb-hero__copy">
        <h3>
          ¡Promover una conversación positiva sobre la migración es posible!
        </h3>
        <p>
          La comunicación es una poderosa herramienta para responder al aumento
          de la xenofobia y generar las condiciones necesarias para una
          inclusión plena de la población migrante en América Latina y el
          Caribe.
          <br />
          Esta guía ofrece recursos y recomendaciones para quienes muestren
          interés en diseñar una estrategia de comunicación para promover la
          integración y enfrentar los prejuicios.
        </p>
      </div>
      <div className="xpb-header__logosContainer">
          <img src="\images\toolkitLogos\BID_Eslogan_ESP_gray.png" alt="bid"></img>
          <img src="\images\canada.png" alt="canada"></img>
          <img src="\images\toolkitLogos\logo full transparente.png" alt="quito"></img>
      </div>
      <div className="xpb-hero__image xpb-hero__image--footer" />
    </section>
  );
}
